import isOneLineTextHtmlElement, { TOneLineTextHtmlElement } from '@atlas/tool/box/dom/isOneLineTextHtmlElement';
import isMultiLineTextHtmlElement, { TMultiLineTextHtmlElement } from '@atlas/tool/box/dom/isMultiLineTextHtmlElement';

export default function isTextHtmlElement(node: Node): node is TTextHtmlElement {
    return isOneLineTextHtmlElement(node) || isMultiLineTextHtmlElement(node);
}

// #region Types

export type TTextHtmlElement = TOneLineTextHtmlElement | TMultiLineTextHtmlElement;

// #endregion

// #region Tests

if (import.meta.vitest) {
    const { describe, test, expect, expectTypeOf } = import.meta.vitest;
    describe('isTextHtmlElement', () => {
        test('results with false for non-html elements', () => {
            expect(isTextHtmlElement(document)).toBe(false);
            expect(isTextHtmlElement(document.createTextNode('text'))).toBe(false);
        });

        test('results with true only for text-convertible html elements', () => {
            expect(isTextHtmlElement(document.createElement('p'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('div'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('h1'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('h2'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('h3'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('h4'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('h5'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('h6'))).toBe(true);
            expect(isTextHtmlElement(document.createElement('iframe'))).toBe(false);
        });

        test('justifies type of the given node to match the result of comparison', () => {
            const node: Node = document;

            isTextHtmlElement(node)
                ? expectTypeOf(node).toMatchTypeOf<
                      HTMLParagraphElement | HTMLDivElement | HTMLHeadingElement | HTMLPreElement | HTMLQuoteElement
                  >()
                : expectTypeOf(node).not.toMatchTypeOf<
                      HTMLParagraphElement | HTMLDivElement | HTMLHeadingElement | HTMLPreElement | HTMLQuoteElement
                  >();
        });
    });
}

// #endregion
